import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { createSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { signedIn } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    createSession(sid)
      .then((u) => {
        localStorage.removeItem("gh-chat-sid");
        signedIn(u);
        toast.success(`Signed in as ${u.name}`);
      })
      .catch(() => toast.error("Sign-in failed. Please try again."))
      .finally(() => navigate(location.pathname, { replace: true }));
  }, [location, navigate, signedIn]);

  return <div className="min-h-[60vh]" data-testid="auth-callback" />;
};
